import { render, staticRenderFns } from "./SignUpComponenOnboarding.vue?vue&type=template&id=113bea57&"
import script from "./SignUpComponenOnboarding.vue?vue&type=script&lang=js&"
export * from "./SignUpComponenOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./SignUpComponenOnboarding.vue?vue&type=style&index=0&id=113bea57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports